import morpion from '../../res/morpion.png';
import memory from '../../res/memory.png';
import devinettes from '../../res/devinettes.png';

export const games = [
    {
        picture: morpion,
        name: 'Morpion',
        url:'/morpion-contre-ordinateur'
    },

    {
        picture: memory,
        name: 'Memory',
        url:'/memory'
    },

    {
        picture: devinettes,
        name: 'Devinettes',
        url:'/devinettes'
    },
];